import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import * as Buttons from 'theme/components/Buttons.style';
import * as Text from 'theme/components/Text.style';
import { Page } from 'layout/styles/PageLayout.style';

export const StyledLink = styled.a`
  align-items: center;
  box-sizing: border-box;
  color: black;
  display: flex;
  font-size: 16px;
  font-weight: 400;
  gap: 10px;
  margin: 0;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
    cursor: pointer;
  }
`;

export const Row = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;

  @media (max-width: ${breakpoints.mobileL}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Header = styled('div')`
  align-items: center;
  display: flex;
  justify-content: space-between;

  @media (max-width: ${breakpoints.tablet}) {
    align-items: flex-start;
    flex-direction: column;
    gap: 30px;
  }
`;

export const HeaderActions = styled('div')`
  display: flex;
  gap: 30px;

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
  }
`;

export const ShareButton = styled('div')`
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 10px;

  &:hover {
    p {
      text-decoration: none;
    }
  }
`;

export const PageNumber = styled('span')`
  color: ${colours.blue[500]};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: ${colours.blue[700]};
  }
`;

export const ExternalLink = styled.a`
  align-items: center;
  background-color: ${colours.neutral[100]};
  color: ${colours.blue[600]};
  cursor: pointer;
  display: flex;
  font-size: 16px;
  font-weight: 500;
  gap: 8px;
  padding: 0;
  width: 100%;

  &:hover {
    color: ${colours.blue[700]};
  }
`;

export const DocumentIframe = styled.iframe<{ onPage?: boolean }>`
  background-color: transparent;
  border: ${(props) =>
    props.onPage ? 'none' : `1px solid ${colours.neutral[300]}`};
  border-radius: ${(props) => (props.onPage ? '15px' : '20px')};
  height: ${(props) => (props.onPage ? '100%' : '700px')};
  min-height: ${(props) => (props.onPage ? '0' : '700px')};
  margin-top: ${(props) => (props.onPage ? '0px' : '15px')};
  width: 100%;
`;

export const DocumentTitleGroup = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
`;

export const DocumentSubtitle = styled(Text.P1)`
  color: ${colours.neutral[500]};
`;

export const Divider = styled('div')`
  background-color: ${colours.neutral[200]};
  flex-shrink: 0;
  height: 2px;
  width: 100%;
`;

export const MostRelevantSection = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
  width: 100%;
`;

export const MostRelevantLabel = styled(Text.P1Bold)`
  color: ${colours.neutral[900]};
`;

export const PageChipsScroller = styled('div')`
  display: flex;
  gap: 5px;
  overflow-x: auto;
  scrollbar-width: none;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const PageChip = styled(Buttons.SecondaryLight)`
  flex-grow: 0;
  flex-shrink: 0;
  white-space: nowrap;
  width: fit-content;

  @media (max-width: ${breakpoints.tablet}) {
    flex-grow: 0;
    width: fit-content;
  }
`;

export const DocumentViewport = styled('div')`
  background-color: ${colours.neutral[200]};
  border-radius: 15px;
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  width: 100%;
`;

export const DocumentContent = styled('div')`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 15px;
  min-height: 0;
  width: 100%;
`;

export const DocumentPageWrapper = styled(Page)`
  gap: 0;

  > div {
    overflow: visible;
  }
`;
